<template>
    <div class="p-10">
        <!-- <h3></h3> -->
        <div class="row">
            <div class="col-lg-4 col-10">
                <div class="title h-100">
                    <i class="fa fa-arrow-left fa-2x mr-3" @click="backPage"></i> 
                    <h3 class="mb-0">Stock Opname</h3>
                </div>
            </div>
            <!-- <div class="col-lg-3 col-12 row mb-1">
                <div class="col-6">
                    <button 
                        class="btn w-100 h-100" 
                        :class="{'btn-dark-blue' : selected == 'Surprise' , 'btn-lg-grey' : selected != 'Surprise'}"
                        @click="selected = 'Surprise'"
                    >
                        Surprise
                    </button>
                </div>
                <div class="col-6">
                    <button 
                        class="btn w-100 h-100" 
                        :class="{'btn-dark-blue' : selected == 'Terjadwal' , 'btn-lg-grey' : selected != 'Terjadwal'}"
                        @click="selected = 'Terjadwal'"
                    >
                        Terjadwal
                    </button>
                </div>
            </div> -->
            <div class="col-lg-3 col-12"></div>
            <div class="col-lg-5 col-12  mb-1">
                <div class="row">
                    <div class="col-4">
                        <!-- <Multiselect 
                            class="w-100"
                            :options="[]"
                            v-model="filter.status"
                            placeholder="All Status"
                        /> -->
                    </div>
                    <div class="col-4">
                        <!-- <Multiselect 
                            class="w-100"
                            :options="[]"
                            v-model="filter.dealer"
                            placeholder="All Dealer"
                        /> -->
                    </div>
                    <div class="col-4">
                        <button class="btn w-100 h-100 btn-green" @click="requestOpname">Request Opname</button>
                    </div>
                </div>
            </div>
        </div>

        <div class="bg-white mt-5 p-30 rounded">
            <div class="row" style="height:30px;">
                <div class="col-6">
                    <h3>{{detailData ? detailData.nama_dealer : 'Loading....'}}</h3>
                </div>
                <div class="col-6 pr-5 text-right" >
                    <span class="h3" style="margin-bottom:0;margin-top:15px;font-size:24px">{{detailData ? detailData.jumlah_unit : 'Loading....'}} </span><span>Unit</span>
                </div>
            </div>

            <div class="row mt-5" style="overflow-wrap: break-word;">
                <div class="col-lg-1 col-6">
                    <span class="sub-header-var">PIC</span>
                    <br>
                    <br>
                    <span class="sub-header-item">{{detailData ? detailData.nama_pic : 'Loading....'}}</span>
                </div>
                <div class="col-lg-1 col-6">
                    <span class="sub-header-var">Platform</span>
                    <br>
                    <br>
                    <span class="sub-header-item">{{detailData ? detailData.platform ? detailData.platform : '-' : 'Loading....'}}</span>
                </div>
                <div class="col-lg-2 col-6">
                    <span class="sub-header-var">Tanggal</span>
                    <br>
                    <br>
                    <span class="sub-header-item">{{detailData ? detailData.tgl_mulai : 'Loading....'}}</span>
                </div>
                <div class="col-lg-2 col-6">
                    <span class="sub-header-var">Durasi</span>
                    <br>
                    <br>
                    <span class="sub-header-item">{{detailData ? detailData.durasi : 'Loading....'}}</span>
                </div>
                <div class="col-lg-2 col-6">
                    <span class="sub-header-var">Lokasi</span>
                    <br>
                    <br>
                    <span style="cursor:pointer;color: #134f97!important;" class="sub-header-item hoverable" @click="showMap($route.params.id ,'/api/detail-lokasi-opname?opname_id=' )">Lihat Map <img src="@/assets/img/google-maps.svg" class="img-fluid" style="height:20px;width:20px" /></span>
                </div>
                <div class="col-lg-1 col-6">
                    <span class="sub-header-var">Status</span>
                    <br>
                <br>
                    <!-- 
                        style_condition : {
                            'In Progress' : 'color : #C6A700',
                            'Done' : 'color : #00B14B',
                            'Open' : 'color : #E02525',
                            'Expired' : 'color:#A3A3A3',
                        }
                    -->
                    <span class="sub-header-item" style="color:#C6A700 !important" v-if="detailData.status == 'In Progress'">{{detailData ? detailData.status : 'Loading....'}}</span>
                    <span class="sub-header-item" style="color:#00B14B !important" v-else-if="detailData.status == 'Done'">{{detailData ? detailData.status : 'Loading....'}}</span>
                    <span class="sub-header-item" style="color:#E02525 !important" v-else-if="detailData.status == 'Open'">{{detailData ? detailData.status : 'Loading....'}}</span>
                    <span class="sub-header-item" style="color:#A3A3A3 !important" v-else-if="detailData.status == 'Expired'">{{detailData ? detailData.status : 'Loading....'}}</span>
                </div>
                <div class="col-lg-3 col-6">
                    <span class="sub-header-var">Lokasi Dealer</span>
                    <br>
                    <br>
                    <span class="sub-header-item">{{detailData ? detailData.lokasi_dealer : 'Loading....'}}</span>
                </div>
            </div>

            <vue-universal-table 
                v-if="tableData"
                class="mt-5"
                :thead_background_color="'#D8E8ED'"
                :data="tableData"
                :table_striped="false"
                :fields="table.fields"
                :filter="filter"
                @onLihatDetail="showDetail"
                @onPeta="showMap"
                @onPhoto="showPhoto"
            />
        </div>
        
        <MapPopup 
            v-if="showMapPage"
            @closeModal="showMapPage = false"
            :urlAPI="url"
            :fields="fields"
        />

        <PreviewImage 
			v-if="photo.length > 0"
			@closeModal="photo = []"
			:image="photo"
        />
    </div>
</template>

<script>
    import qs from 'qs'
    import customFilter from '@/components/filter/customFilter'
    import Multiselect from 'vue-multiselect'
    import moment from 'moment'

    // Children
    import MapPopup from '@/components/MapPopup.vue'

    import PreviewImage from '@/components/previewImage'

    export default {
        metaInfo : {
            title : 'Stock Opname'
        },
        components : {
            Multiselect,
            MapPopup,
            PreviewImage
        },
        methods : {
            backPage () {
                this.$router.push({name : this.$route.query.from})
            },
            showPhoto (data) {
                // console.log(data)
                this.photo = [data.split('"').join('')]
            },
            showMap (id, url = '/api/detail-scan?id=') {

                if(url == '/api/detail-scan?id=')
                    this.fields = [{
                        title : 'Qrcode',
                        variable : 'qrcode'
                    },{
                        title : 'Serial',
                        variable : 'serial'
                    },{
                        title : 'Type',
                        variable : 'type_desc'
                    },{
                        title : 'Frame No',
                        variable : 'frame_no'
                    },{
                        title : 'Engine No',
                        variable : 'engine_no'
                    },{
                        title : 'Color',
                        variable : 'color_desc'
                    },{
                        title : 'Lat',
                        variable : 'lat'
                    },{
                        title : 'Lng',
                        variable : 'lng'
                    },{
                        title : 'Lokasi Scan',
                        variable : 'lokasi_scan'
                    },{
                        title : 'GR MD',
                        variable : 'gr_md',
                        date : true
                    },{
                        title : 'GI MD',
                        variable : 'gi_md',
                        date : true
                    },{
                        title : 'GR D',
                        variable : 'gr_d',
                        date : true
                    },{
                        title : 'Umur Unit',
                        variable : 'umur_unit'
                    }]
                else
                    this.fields = null

                this.url = url + id
                this.showMapPage = true
            },
            showDetail(id) {
                this.$router.push({name : 'StockOpnameDetail' , params : {id : id}})
            },
            requestOpname() {
                this.$router.push({name : 'StockOpnameRequest'})
            },
            async loadData () {
                try {
                    let response = await this.$http.get('/api/detail-opname?opname_id=' + this.$route.params.id)

                    let data = response.data.data
                    // console.log(data)

                    this.tableData = data.detail.map(x => {
                        x.photo == '-' ? x.photo = '\nNo Image' : ''
                        return {
                            ...x,
                            peta : require('@/assets/img/google-maps.svg')
                        }
                    })

                    this.detailData = data
                    // console.log(this.tableData)
                }
                catch(err) {
                    console.log(err)
                }
            }
        },
        data () {
            return {
                url : '', 
                showMapPage : false,
                photo : [],
                moment,
                tableData : null,
                detailData : null,
                mapCoordinates : null,
                filter : {
                    opname_id : this.$route.params.id
                },
                selected : 'Surprise',
                sampleData : [{
                    id : 1,
                    unit : 'Honda Vario 160cc',
                    color : 'Grande Matte White',
                    gr_md : '20/10/2022 - 13:00',
                    gi_md : '20/10/2022 - 13:00',
                    gr_d : '20/10/2022 - 13:00 WIT',
                    no_mesin : 'MH1JF21178K12164',
                    no_ranga : 'MH3SEF320JJ000105',
                    umur_unit : '1 Hari',
                    scan_time : '20/10/2022 - 13:00 WIT',
                    keterangan : 'Unit Sedang Di Repair',
                    photo_taken : 'Photo (WIP)',
                    peta : 'Icon (WIP)'
                },{
                    id : 2,
                    unit : 'Honda Vario 160cc',
                    color : 'Grande Matte White',
                    gr_md : '20/10/2022 - 13:00',
                    gi_md : '20/10/2022 - 13:00',
                    gr_d : '20/10/2022 - 13:00 WIT',
                    no_mesin : 'MH1JF21178K12164',
                    no_ranga : 'MH3SEF320JJ000105',
                    umur_unit : '1 Hari',
                    scan_time : '20/10/2022 - 13:00 WIT',
                    keterangan : 'Unit Sedang Di Repair',
                    photo_taken : 'Photo (WIP)',
                    peta : 'Icon (WIP)'
                },{
                    id : 3,
                    unit : 'Honda Vario 160cc',
                    color : 'Grande Matte White',
                    gr_md : '20/10/2022 - 13:00',
                    gi_md : '20/10/2022 - 13:00',
                    gr_d : '20/10/2022 - 13:00 WIT',
                    no_mesin : 'MH1JF21178K12164',
                    no_ranga : 'MH3SEF320JJ000105',
                    umur_unit : '1 Hari',
                    scan_time : '20/10/2022 - 13:00 WIT',
                    keterangan : 'Unit Sedang Di Repair',
                    photo_taken : 'Photo (WIP)',
                    peta : 'Icon (WIP)'
                },{
                    id : 4,
                    unit : 'Honda Vario 160cc',
                    color : 'Grande Matte White',
                    gr_md : '20/10/2022 - 13:00',
                    gi_md : '20/10/2022 - 13:00',
                    gr_d : '20/10/2022 - 13:00 WIT',
                    no_mesin : 'MH1JF21178K12164',
                    no_ranga : 'MH3SEF320JJ000105',
                    umur_unit : '1 Hari',
                    scan_time : '20/10/2022 - 13:00 WIT',
                    keterangan : 'Unit Sedang Di Repair',
                    photo_taken : 'Photo (WIP)',
                    peta : 'Icon (WIP)'
                },{
                    id : 5,
                    unit : 'Honda Vario 160cc',
                    color : 'Grande Matte White',
                    gr_md : '20/10/2022 - 13:00',
                    gi_md : '20/10/2022 - 13:00',
                    gr_d : '20/10/2022 - 13:00 WIT',
                    no_mesin : 'MH1JF21178K12164',
                    no_ranga : 'MH3SEF320JJ000105',
                    umur_unit : '1 Hari',
                    scan_time : '20/10/2022 - 13:00 WIT',
                    keterangan : 'Unit Sedang Di Repair',
                    photo_taken : 'Photo (WIP)',
                    peta : 'Icon (WIP)'
                },{
                    id : 6,
                    unit : 'Honda Vario 160cc',
                    color : 'Grande Matte White',
                    gr_md : '20/10/2022 - 13:00',
                    gi_md : '20/10/2022 - 13:00',
                    gr_d : '20/10/2022 - 13:00 WIT',
                    no_mesin : 'MH1JF21178K12164',
                    no_ranga : 'MH3SEF320JJ000105',
                    umur_unit : '1 Hari',
                    scan_time : '20/10/2022 - 13:00 WIT',
                    keterangan : 'Unit Sedang Di Repair',
                    photo_taken : 'Photo (WIP)',
                    peta : 'Icon (WIP)'
                }],
                fields : null,
                table : {
                    buttons : [{
                        title : 'LihatDetail',
                        class : 'btn',
                        variable : 'id'
                    }],
                    fields : [
                        {
                            title : "ID",
                            variable : "id",
                        },
                        {
                            title : "Unit",
                            variable : "type_desc",
                        },
                        {
                            title : "Color",
                            variable : "color_desc",
                        },
                        {
                            title : "GR MD",
                            variable : "gr_md",
                        },
                        {
                            title : "GI MD",
                            variable : "gi_md",
                        },
                        {
                            title : "GR D",
                            variable : "gr_d",
                        },
                        {
                            title : "No Mesin",
                            variable : "engine_no",
                        },
                        {
                            title : "No Rangka",
                            variable : "frame_no",
                        },
                        {
                            title : "Umur Unit",
                            variable : "umur_unit",
                        },
                        {
                            title : "Scan Time",
                            variable : "tgl_scan",
                        },
                        {
                            title : "Keterangan",
                            variable : "keterangan",
                        },
                        {
                            title : "Photo Taken",
                            variable : "photo",
                            emit_variable : 'photo',
                            class : "clickAble",
                            is_image : true
                        },
                        {
                            title : "Peta",
                            variable : "peta",
                            class : "clickAble",
                            emit_variable : 'id',
                            is_image : true
                        },
                    ]
                }
            }
        },
        mounted () {
            this.loadData()
        }
    }
</script>

<style>
    .clickAble {
        cursor: pointer;
    }
</style>

<style scoped>
    .sub-header-var {
        font-size: 16px !important;
        color : #939393 !important;
    }

    .sub-header-item {
        font-size: 16px !important;
        color : black !important;
    }

    .hoverable:hover {
        background-color : rgb(206, 231, 139);
    }

</style>